import React from "react";
import projectList from "./ProjectList";


import ProjectsCard from "../projectsCard/ProjectsCard"//A template to view student posts

import "./ProjectsGrid.scss";



class ProjectsGrid extends React.Component{

    render() {
        return(
            <div className="p-2 grid-container row">
                {projectList.map((project, index) => {
                    return(
                        <ProjectsCard
                            name={project.name}
                            imageUrl={project.imageUrl}
                            description={project.description}
                            link={project.projectLink}
                        />
                    );
                })}
            </div>
        );

    }
}

export default ProjectsGrid;